import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';

registerFragment('chroa-membership-cards-list', (fragmentElement, configuration, meta) => {

    function setHeight(): void {
        //console.log("before");
        const membershipList: NodeListOf<Element> = fragmentElement.querySelectorAll('.chroa-membership-card--list-item');
        //console.log(membershipList.length);
        let nheight: number = 0;
        let tempb: string = "";

        for (let x = 0; x < membershipList.length; x++) {
            //membershipList[x].innerHTML = ` `;
            const tempv: NodeListOf<HTMLHeadingElement> = membershipList[x].querySelectorAll("h3");
            //console.log(tempv[0].clientHeight);
            // console.log(x);
            if (nheight < tempv[0].clientHeight) {
                nheight = tempv[0].clientHeight;
            }
            //  console.log(nheight);
            nheight= nheight + 27;
            //   console.log(nheight);
        }
        // console.log(nheight);
        for (let x = 0; x < membershipList.length; x++) {
            //  console.log(x);
            const tempv: NodeListOf<HTMLHeadingElement> = membershipList[x].querySelectorAll(".chroa-membership-card--content__inner");
            //   console.log(tempv + " " + nheight);
            // tempv[0].style.maxHeight = nheight + "px";
            tempv[0].style.minHeight = nheight + "px";
            // tempv[0].style.height = nheight + "px";
        }
    }

    setHeight();
    window.addEventListener('resize', function(event) {
        // console.log("resized");
        setHeight();
    });
});

if (import.meta.hot) {
    import.meta.hot.accept();
}







